// ── Translations ──────────────────────────────────────────────────────────────
// English-only for now. Simplified / Traditional Chinese will be re-added later
// (kept in this structure so re-adding is just extra language blocks + a switcher).

export const LANGS = [
  { id: 'en', label: 'EN', name: 'English' },
];

export const T = {
  en: {
    meta: {
      title: 'The Cove Counselling',
      description: 'The Cove is a private counselling practice in Hong Kong offering therapy in English, Mandarin and Cantonese. A sheltered space. No judgment. Just come as you are.',
    },
    nav: { home: 'Home', about: 'About', services: 'Services', process: 'Fees', faq: 'FAQ', contact: 'Contact', testimonials: 'Testimonials' },
    brand: { name: 'The Cove', sub: 'Counselling', cn: '' },
    common: { bookCta: 'Take the first step', langsLine: 'English/普通话/廣東話' },
    footer: {
      explore: 'Explore',
      testimonials: 'Client Testimonials',
      contactHeading: 'Contact',
      location: 'AMindset Psychology Services, Central',
      crisisHeading: 'In a crisis?',
      crisisPre: 'The Cove is not an emergency service. If you are in Hong Kong and need help now, call 999 or view our ',
      crisisLink: 'emergency resources',
      crisisPost: '.',
      tagline: 'A space to come back to yourself.',
      rights: '© 2026 The Cove Counselling. All rights reserved.',
      privacy: 'Privacy Policy',
      emergency: 'Emergency Resources',
    },
    home: {
      heroLines: ['A place to stop performing'], heroAccent: '“fine.”',
      heroSubhead: 'Counselling for high-achieving adults navigating work, relationships, and questions of meaning.',
      heroWhat: 'Online and in Hong Kong, in English and Mandarin.',
      heroLangs: 'English/普通话/廣東話',
      heroWhere: 'Online & in person in Hong Kong',
      heroCta: 'Start with a conversation',
      quoteBridge: 'This is where people who’ve spent years being competent for everyone else finally get to exhale.',
      quoteLines: ['A cove offers what the open sea cannot:', 'shelter enough to stop performing,', 'and room enough to '], quoteAccent: 'start exploring.',
      quoteSupport: 'Feel your way through whatever you are carrying, and reconnect with what matters most to you.',
      aboutLink: 'About The Cove',
      whoEyebrow: 'Who comes to The Cove',
      whoHeading: "You don't have to arrive ready.",
      whoIntro: 'There is no threshold to cross before you begin, and no story too small or too tangled to bring here. You don’t need the right label or a single clear reason to start.',
      whoCards: [
        { label: 'The cost of high performance', desc: 'The pressure of holding yourself to a high standard, and **the tiredness that rarely shows**. A place to set down what you have been carrying for everyone else.' },
        { label: 'Relationships and family', desc: 'The people closest to you, and **the patterns that keep repeating**. The kind of **loneliness** that can settle in even when a life looks full from the outside.' },
        { label: 'Meaning and direction', desc: 'Low mood, or the quieter question underneath it: **whether this is really the life you want**, and what you might want instead.' },
      ],
      servicesLink: 'Explore the services',
      meetEyebrow: 'Your counsellor',
      meetHeadingPre: "Hello, I'm ", meetHeadingAccent: 'Lindsey.',
      meetParas: [
        'Before I trained as a counsellor, I spent years in demanding professional work, and it was good work. But I wanted to do work where people were people, not resources.',
        'I was born and raised in mainland China, educated in the United States, and Hong Kong has been home for more than a decade. I work in English, Mandarin, and Cantonese, with people who are capable, high-achieving, and often quietly tired.',
        'I do not believe I hold the truth about your life. You do. My work is to help you find your own way around it, and to be good company while you do.',
      ],
      meetLink: 'Read my full story',
      ctaEyebrow: 'The relationship comes first',
      ctaHeading: "Whenever you're ready.",
      ctaBody: ['Finding a therapist who truly fits you matters more than anything, and it’s something we find out together.'],
      testimonials: {
        eyebrow: 'Hear it from my clients',
        heading: 'What clients say.',
        note: 'Shared with permission. Initials are used to protect each person’s privacy.',
        linkLabel: 'Read their words in full',
        pageHeadingPre: 'In ',
        pageHeadingAccent: 'their words.',
        pageIntro: 'These words were generously shared by a few of my clients. I hold a deep gratitude for their trust, and for being allowed to walk alongside them on their journey.',
        backCta: 'Take the first step of your own',
        items: [
          {
            initials: 'A.Z.',
            highlight: 'What I value most is Lindsey’s profound empathy.',
            full: [
              'I met Lindsey at the most difficult moment of my life. It’s a very complicated situation, and everything happened so fast. I didn’t expect that anyone — even the closest friends — could truly understand what I was going through.',
              'After the first time I talked with Lindsey, I was surprised by how well she understood my situation, and her words gave me lots of support and comfort.',
              'Although the circumstances didn’t turn out better, I was able to face each difficult step with her presence and help. And through our sessions, I saw and learned things that I never knew about myself.',
              'What I value most is her profound empathy.',
              'Without her help, I don’t think I would have been able to rebuild my life the way I have.',
            ],
          },
          {
            initials: 'S.S.',
            highlight: 'I feel entirely comfortable pouring out all my messy emotions, without fear of being judged.',
            full: [
              'I have been seeing Lindsey for half a year, and she is naturally gifted as a therapist. I feel entirely comfortable pouring out all my messy emotions without fear of being judged, knowing she always listens carefully and patiently, and quickly pinpoints the core of my rambling thoughts and restates them accurately, making me truly seen and understood.',
              'She asks me thoughtful open-ended questions and guides me to reflect deeply on myself.',
            ],
          },
          {
            initials: 'R.K.',
            highlight: 'It often felt like having a conversation with a trusted friend.',
            full: [
              'Although the time I worked with Lindsey was relatively short, it had a much deeper impact on me than I expected. At first, I often felt overwhelmed by many different issues and emotions. Through our conversations, Lindsey helped me gently unpack and understand what was going on beneath the surface.',
              'What I appreciated most was that our sessions never felt like formal counselling alone. They often felt like having a conversation with a trusted friend. Yet through those conversations, Lindsey guided me towards many important reflections and insights about myself that I might never have reached on my own.',
              'Her support helped me realise that many of the “big problems” I was carrying could actually be broken down into smaller, more manageable parts. That shift in perspective made a meaningful difference to how I approach challenges and understand myself today.',
            ],
          },
        ],
      },
    },
  },
};
